import { trackUtil } from './analytics.service';

export const fireAnalyticsOnLandingPageLoad = () => {
    trackUtil({
        eVar0: `b2b|airtel internet|home page`
    });

}
export const fireAnalyticsOnWorkFromHome = () => {
    trackUtil({
        eVar9: `b2b|dedicated internet|home page|wfh`,
        eVar8: `b2b|dedicated internet|home page`,
    });
}
export const fireAnalyticsOnTryNowButton = () => {
    trackUtil({
        eVar9: `b2b|dedicated internet|home page|try now`,
        eVar8: `b2b|dedicated internet|home page`,
    });
}
export const fireAnalyticsOnCheckFeasibilityLink = linkText => {
    trackUtil({
        eVar9: `b2b|dedicated internet|home page|`+linkText,
        eVar8: `b2b|dedicated internet|home page`,
    });
}
export const fireAnalyticsOnTopSellingLink = () => {
    trackUtil({
        eVar9: `b2b|dedicated internet|home page|view plans`,
        eVar8: `b2b|dedicated internet|home page`,
    });
}
export const fireAnalyticsOnFeasibilityPageLoad = () => {
    trackUtil({
        eVar0: `b2b|dedicated internet|home page|feasibility`
    });

}
export const fireAnalyticsOnNextButtonClick = data => {
    trackUtil({
        eVar9: `b2b|dedicated internet|home page|feasibility|next`,
        eVar8: `b2b|dedicated internet|home page|feasibility`,
        prop16:data && data.customerDetails && data.customerDetails.selectedCity,
        prop19:data && data.customerDetails && data.customerDetails.pincode,
        prop20:data && data.customerDetails && data.customerDetails.address
    });
}
export const fireAnalyticsOnCustomerPageLoad = () => {
    trackUtil({
        eVar0: `b2b|dedicated internet|home page|feasibility|contact details`
    });

}
export const fireAnalyticsOnProceedButtonClick = data => {
    trackUtil({
        eVar9: `b2b|dedicated internet|home page|feasibility|contact details|proceed`,
        eVar8: `b2b|dedicated internet|home page|feasibility|contact details`,
        prop35:data && data.companyName,
        prop17:data && data.customerName,
        prop15:data && data.email,
        prop14:data && data.phoneNumber
    });
}
export const fireAnalyticsOnChoosePlanPageLoad = () => {
    trackUtil({
        eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan`
    });
}
export const fireAnalyticsOnSelectPlanButtonClick = data => {
    trackUtil({
        eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|select`,
        eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan`,
        prop18:data && data.price && data.price.amount,
    });
}
export const fireAnalyticsOnArpPlanLoad = () => {
    trackUtil({
        eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|bill duration`
    });
}
export const fireAnalyticsOnPlanDurationButtonClick = data => {
    trackUtil({
        eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|bill duration|confirm`,
        eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|bill duration`,
        prop18:data && data.price && data.price.amount,
    });
}
export const fireAnalyticsOnKnowMoreLoad = () => {
    trackUtil({
        eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|know more`
    });
}
export const fireAnalyticsOnsummaryPageLoad = () => {
    trackUtil({
        eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|bill duration|booking summary`
    });
}
export const fireAnalyticsOnSummaryButtonClick = (data, offerOTC, offerPrice) => {
    let prop18 = 0;
    let prop22=data && data.price && data.price.amount;
    if(data && data.price && data.price.amount && data.choosedARP){
        prop18=data.price.amount*parseInt(data.choosedARP)+data.price.otc+(0.18*(data.price.amount*parseInt(data.choosedARP)+data.price.otc));
        prop22=data.price.amount*parseInt(data.choosedARP);
    }
    trackUtil({
        eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|bill duration|booking summary|submit`,
        eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|bill duration|booking summary`,
        prop18: prop18 && prop18 > 0 &&  Math.round(prop18),
        prop23:data && data.price && data.price.otc,
        prop22:Math.round(prop22),
    });
}
export const fireAnalyticsOnThankYouPageLoad = (type,requestedId) => {
    trackUtil({
        eVar0: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|bill duration|booking summary|`+type+`|thank you`,
        prop21:requestedId
    });
}
export const fireAnalyticsOnTalkToExpertButtonClick = data => {
    trackUtil({
        eVar9: `b2b|dedicated internet|home page|talk to expert`,
        eVar8: `b2b|dedicated internet|home page`,
    });
}
export const fireAnalyticsOnTalkToExpertPageLoad = () => {
    trackUtil({
        eVar0: `b2b|dedicated internet|home page|talk to expert`
    });
}
export const fireAnalyticsOnTalkToExpertSubmit = (mobileNumber,emailId,city,customerName, companyName) => {
    trackUtil({
        eVar9: `b2b|dedicated internet|home page|talk to expert|submit`,
        eVar8: `b2b|dedicated internet|home page`,
        prop14:mobileNumber,
        prop15:emailId,
        prop16:city,
        prop17:customerName,
        prop18:companyName,
    });
}
export const fireAnalyticsOnProceedPlanButtonClick = data => {
    trackUtil({
        eVar9: `b2b|dedicated internet|home page|feasibility|contact details|choose plan|proceed`,
        eVar8: `b2b|dedicated internet|home page|feasibility|contact details|choose plan`,
    });
}
